import PropTypes from "prop-types";
import React from "react";
import Rail from "web/react/components/rail/rail";
import classnames from "classnames";
import RelatedSearchProductImages from "./related-search-product-images";
import styles from "./related-searches-rail.css";

function RelatedSearchesRail({ title, relatedSearches, showImages, inlineImages, features }) {
    let breadCrumbCount = 0;
    return (
        <Rail
            title={title}
            analyticsLabel="related_searches"
            className={styles.railWrapper}
            itemScope=""
            itemType="http://schema.org/BreadcrumbList"
            peekingCard={features.uj_peeking_card}
        >
            {relatedSearches.map((relatedSearch) => {
                if (relatedSearch.is_breadcrumb) {
                    breadCrumbCount++;
                }
                return (
                    <div
                        className={styles.cardWrapper}
                        key={relatedSearch.url}
                        itemProp={relatedSearch.is_breadcrumb ? "itemListElement" : undefined}
                        itemScope={relatedSearch.is_breadcrumb ? "" : undefined}
                        itemType={
                            relatedSearch.is_breadcrumb ? "http://schema.org/ListItem" : undefined
                        }
                    >
                        <div
                            className={classnames(styles.relatedSearchCard, {
                                [styles.relatedSearchCardInline]: inlineImages,
                            })}
                        >
                            {showImages && (
                                <a
                                    href={relatedSearch.url}
                                    itemProp={relatedSearch.is_breadcrumb ? "item" : undefined}
                                >
                                    <RelatedSearchProductImages
                                        feedUrl={relatedSearch.url}
                                        isRoundedImage={inlineImages === true}
                                        showFallBack={inlineImages === true}
                                    />
                                </a>
                            )}
                            <a
                                href={relatedSearch.url}
                                className={styles.relatedSearchTerm}
                                itemProp={relatedSearch.is_breadcrumb ? "item" : undefined}
                            >
                                {relatedSearch.text}
                            </a>
                        </div>
                        {relatedSearch.is_breadcrumb && (
                            <meta itemProp="position" content={breadCrumbCount} />
                        )}
                    </div>
                );
            })}
        </Rail>
    );
}

RelatedSearchesRail.defaultProps = {
    showImages: true,
    inlineImages: false,
};

RelatedSearchesRail.propTypes = {
    title: PropTypes.string,
    features: PropTypes.objectOf(PropTypes.string),
    relatedSearches: PropTypes.array.isRequired,
    showImages: PropTypes.bool,
    inlineImages: PropTypes.bool,
};

export default RelatedSearchesRail;
